import React, { useEffect, useState } from 'react';
import { Button, Input, Card, CardBody, CardHeader, FormGroup, Label, Form, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import { api } from "../../config";
import { filter } from 'lodash';
import { fetchComAuth, fetchComAuthJson } from '../../common/api';

const TelaConfiguracoesTipoEspaco = ({ feiraId, editando }) => {
  // Estados principais
  const [tiposEspaco, setTiposEspaco] = useState([]);
  const [availableTiposEspaco, setAvailableTiposEspaco] = useState([]);
  const [filteredAvailableTiposEspaco, setFilteredAvailableTiposEspaco] = useState([]); // Tags disponíveis filtradas
  const [modalAberto, setModalAberto] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [tipoEspacoId, setTipoEspacoId] = useState('');
  const [cor, setCor] = useState(false);
  const [agrupado, setAgrupado] = useState(false);
  const [permiteCirculacao, setPermiteCirculacao] = useState(false);
  const SUGESTOES_MAPA = [
    { nome: "Restaurante", icon: "bx bx-restaurant", tags: "comida, food, lanche, restaurante" },
    { nome: "Banheiros", icon: "bx bx-male-female", tags: "wc, banheiro, toilette, sanitarios" },
    { nome: "Elevador", icon: "bx bx-up-arrow-alt", tags: "subir, elevador, andar" },
    { nome: "Escada", icon: "bx bx-trending-up", tags: "escada, degrau" },
    { nome: "Entrada/Saída", icon: "bx bxs-door-open", tags: "entrada, saida, portão, porta"},
    { nome: "Entrada", icon: "bx bx-log-in-circle", tags: "entrada, porta, acesso" },
    { nome: "Saída", icon: "bx bx-log-out-circle", tags: "saida, exit, emergencia" },
    { nome: "Cadeirante / PCD", icon: "bx bx-accessibility", tags: "cadeirante, acessibilidade, pcd, cadeirante" },
    { nome: "Heliponto", icon: "bx bx-crosshair", tags: "heliponto, helicoptero, pouso" },
    { nome: "Estacionamento", icon: "bx bxs-parking", tags: "carro, estacionamento, vagas" },
    { nome: "Credenciamento", icon: "bx bx-id-card", tags: "checkin, cadastro, cracha, recepcao" },
    { nome: "Auditório", icon: "bx bx-group", tags: "palestra, sala, auditorio, palco" },
    { nome: "Área Descanso", icon: "bx bx-chair", tags: "descanso, sofa, cafe, lounge" },
    { nome: "Informação", icon: "bx bx-info-circle", tags: "ajuda, info, balcao, informações" },
    { nome: "Espaço família", icon: "bx bx-smile", tags: "família, crianças, espaço, fraldário" },
    { nome: "Área kids", icon: "bx bx-child", tags: "crianças, área kids" },
    { nome: "Área pet", icon: "bx bxs-dog", tags: "pet, cachorro, gato" },
    { nome: "Café", icon: "bx bx-coffee", tags: "cafe" },

  ];

  const [icone, setIcone] = useState('bx bxs-map');
  const [termoBusca, setTermoBusca] = useState('');

  useEffect(() => {
    const carregarDados = async () => {
      try {
        const responseTipos = await fetchComAuth(`${api.API_URL}/tipo-espaco`, {
          method: 'GET'
        });
        const dataTiposEspaco = await responseTipos.json();
        setAvailableTiposEspaco(dataTiposEspaco.data);
  
        if (feiraId && editando) {
          const responseFeiraTiposEspaco = await fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`, {
            method: 'GET'
          });
          const dataFeiraTiposEspaco = await responseFeiraTiposEspaco.json();
          setTiposEspaco(dataFeiraTiposEspaco.data);
          
          // Filtra as tags disponíveis
          const usedTiposEspacoIds = dataFeiraTiposEspaco.data.map(tipo => tipo.tipo_espaco_id);
          const filtered = dataTiposEspaco.data.filter(tipo => !usedTiposEspacoIds.includes(tipo.id));
          setFilteredAvailableTiposEspaco(filtered);
        } else {
          setFilteredAvailableTiposEspaco(dataTiposEspaco.data);
         
        }
      } catch (err) {
        console.error("Erro ao carregar dados:", err);
      }
    };
  
    carregarDados();
  }, [feiraId, editando]);

  // Limpa o formulário
  const limparFormulario = () => {
    setTipoEspacoId('');
    setCor('');
    setIcone('');
    setEditandoId(null);
    setAgrupado(false);
    setPermiteCirculacao(false);
  };

  const handleSalvar = async () => {
    const payload = {
      id: editandoId,
      feira_id: feiraId,
      tipo_espaco_id: tipoEspacoId,
      cor: cor,
      icone: icone,
      agrupado: agrupado,
      permite_circulacao: permiteCirculacao
    };
  
    try {
      const method = editandoId ? 'PUT' : 'POST';
      const response = await fetchComAuthJson(`${api.API_URL}/tiposEspacoFeira`, {
        method: method,
        body: JSON.stringify(payload)
      });
  
      if (response.ok) {
        const updatedResponse = await fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`, {
          method: 'GET'
        });
        const updatedData = await updatedResponse.json();
        setTiposEspaco(updatedData.data);
        
        const usedTipoEspacoIds = updatedData.data.map(tipo => tipo.tipo_espaco_id);
        const filtered = availableTiposEspaco.filter(tipo => !usedTipoEspacoIds.includes(tipo.id));
        setFilteredAvailableTiposEspaco(filtered);
        
        setModalAberto(false);
        limparFormulario();
      }
    } catch (err) {
      console.error('Erro ao salvar o tipo de espaço:', err);
    }
  };

  // Prepara o formulário para edição
  const handleEditar = (tipo) => {
    setTipoEspacoId(tipo.tipo_espaco_id);
    setCor(tipo.cor);
    setEditandoId(tipo.id);
    setIcone(tipo.icone);
    setAgrupado(tipo.agrupado)
    setPermiteCirculacao(tipo.permite_circulacao)
    
    if (!availableTiposEspaco.some(t => t.id === tipo.tipo_espaco_id)) {
      setAvailableTiposEspaco(prev => [...prev, { id: tipo.tipo_espaco_id, nome: tipo.tipo_espaco?.nome || 'Tipo espaço atual' }]);
      setFilteredAvailableTiposEspaco(prev => [...prev, { id: tipo.tipo_espaco_id, nome: tipo.tipo_espaco?.nome || 'Tipo espaço atual' }]);
    }
    
    setModalAberto(true);
  };

  const handleExcluir = async (id) => {
    try {
        await fetchComAuth(`${api.API_URL}/tiposEspacoFeira/${id}`, {
          method: 'DELETE',
        });
        
        const response = await fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`, {
          method: 'GET'
        });
        
        const updatedData = await response.json();
        setTiposEspaco(updatedData.data);
        
        // Atualiza a lista de tags disponíveis
        const usedTipoEspacoIds = updatedData.data.map(tipo => tipo.tipo_espaco_id);
        const filtered = availableTiposEspaco.filter(tipo => !usedTipoEspacoIds.includes(tipo.id));
        setFilteredAvailableTiposEspaco(filtered);
    } catch (err) {
        console.error('Erro ao excluir tipo espaço:', err);
    }
    };

  // Obtém o nome da tag pelo ID
  const getTipoName = (id) => {
    const tipo = availableTiposEspaco.find(t => t.id === id) || 
              tiposEspaco.find(t => t.tipo_espaco_id === id)?.tipo_espaco ||
              { nome: 'Tipo espaço selecionado' };
  
    return tipo.nome;
  };

  return (
    <div>
      <Row>
        <Col lg={12}>
          <Card>
            <CardHeader>
              <Button color="success" onClick={() => { limparFormulario(); setModalAberto(true); }}>
                <i className="ri-add-line align-bottom me-1"></i> Adicionar
              </Button>
            </CardHeader>
            <CardBody>
              <div className="listjs-table" id="tiposEspacoLista">
                {tiposEspaco.length === 0 ? (
                  <p className="text-muted">Nenhum tipo de espaço configurado ainda.</p>
                ) : (
                  <Table className="table align-middle table-nowrap">
                    <thead className="table-light">
                      <tr>
                        <th>Tipo de Espaço</th>
                        <th>Cor</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tiposEspaco.map((tipo) => (
                        <tr key={tipo.id}>
                          <td>{getTipoName(tipo.tipo_espaco_id)}</td>
                          <td>
                            <div style={{ 
                              display: 'inline-flex', 
                              alignItems: 'center', 
                              gap: '8px'
                            }}>
                              <span style={{
                                display: 'inline-block',
                                width: '20px',
                                height: '20px',
                                backgroundColor: tipo.cor,
                                border: '1px solid #dee2e6',
                                borderRadius: '3px'
                              }}></span>
                            </div>
                          </td>
                          <td>
                            <Button color="warning" size="sm" className="me-2" onClick={() => handleEditar(tipo)}>
                              Editar
                            </Button>
                            <Button color="danger" size="sm" onClick={() => handleExcluir(tipo.id)}>
                              Excluir
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal isOpen={modalAberto} toggle={() => setModalAberto(!modalAberto)} centered>
        <ModalHeader toggle={() => setModalAberto(!modalAberto)}>
            {editandoId ? 'Editar Configuração' : 'Nova Configuração'}
        </ModalHeader>
        <ModalBody>
            <Form>
              <FormGroup>
                <Label>Tipo Espaço</Label>
                <Input
                  type="select"
                  value={tipoEspacoId}
                  onChange={(e) => setTipoEspacoId(e.target.value)}
                >
                  <option value="">Selecione um tipo de espaço</option>
                  {/* Opção para o tipo atual em edição */}
                  {editandoId && tipoEspacoId && (
                      <option value={tipoEspacoId}>
                          {getTipoName(tipoEspacoId)}
                      </option>
                  )}
                  
                  {/* Opções para tipos disponíveis */}
                  {filteredAvailableTiposEspaco.map((tipo) => (
                      <option key={tipo.id} value={tipo.id}>
                          {tipo.nome}
                      </option>
                  ))}
              </Input>
            </FormGroup>
            
            <FormGroup>
                <Label>Cor</Label>
                <Input 
                  type="color" 
                  className="form-control form-control-color w-100" 
                  id="cor" 
                  value={cor || "#46b045"}
                  onChange={(e) => setCor(e.target.value)}
                />
            </FormGroup>

            <FormGroup check>
              <Label>Agrupado na pesquisa das rotas</Label>
              <Input 
                className="form-check-input" 
                type="checkbox" 
                role="switch" 
                id="agrupado"
                checked={agrupado}
                onChange={(e) => setAgrupado(e.target.checked)}
                />
            </FormGroup>

            <FormGroup check>
              <Label>Permite circulação pelo espaço</Label>
              <Input 
                className="form-check-input" 
                type="checkbox" 
                role="switch" 
                id="permite_circulacao"
                checked={permiteCirculacao}
                onChange={(e) => setPermiteCirculacao(e.target.checked)}
                />
            </FormGroup>

           <FormGroup>
                  <Label>Ícone do Marcador</Label>
                  <div className="d-flex gap-2 mb-2">
                      <Input 
                          type="text" 
                          placeholder="Pesquise: wc, comida, saida..." 
                          value={termoBusca}
                          onChange={(e) => setTermoBusca(e.target.value)}
                      />
                      <div className="btn btn-light d-flex align-items-center justify-content-center" style={{ width: '50px', border: '1px solid #ced4da' }}>
                          <i className={icone} style={{ fontSize: '24px' }}></i>
                      </div>
                  </div>
                  
                  <div style={{ 
                      maxHeight: '180px', 
                      overflowY: 'auto', 
                      border: '1px solid #ced4da', 
                      borderRadius: '0.25rem',
                      padding: '10px',
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                      gap: '8px',
                      backgroundColor: '#f9f9f9'
                  }}>
                      {SUGESTOES_MAPA.filter(item => 
                          item.nome.toLowerCase().includes(termoBusca.toLowerCase()) || 
                          item.tags.toLowerCase().includes(termoBusca.toLowerCase())
                      ).map(item => (
                          <div 
                              key={item.icon}
                              onClick={() => setIcone(item.icon)}
                              className="text-center p-2 rounded"
                              style={{ 
                                  cursor: 'pointer', 
                                  backgroundColor: icone === item.icon ? '#4b38b3' : 'white',
                                  color: icone === item.icon ? '#fff' : '#333',
                                  border: '1px solid #eee',
                                  fontSize: '11px'
                              }}
                          >
                              <i className={item.icon} style={{ fontSize: '20px', display: 'block' }}></i>
                              {item.nome}
                          </div>
                      ))}
                  </div>
            </FormGroup>

            </Form>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={() => setModalAberto(false)}>Cancelar</Button>
            <Button color="primary" onClick={handleSalvar}>
            {editandoId ? 'Atualizar' : 'Salvar'}
            </Button>
        </ModalFooter>
        </Modal>
    </div>
  );
};

export default TelaConfiguracoesTipoEspaco;